import {
  COL_STYLE,
  getTenantEditPageTitle,
  ROW_STYLE,
  TENANT_COMMON_TITLES,
  TENANT_LOGO_DIMENSIONS,
  TENANT_SECTIONS_TO_VALIDATE,
  TENANT_SETTINGS_PATHS,
  TENANT_SETTINGS_SECTIONS
} from '../constants'

export {
  COL_STYLE,
  getTenantEditPageTitle,
  ROW_STYLE,
  TENANT_COMMON_TITLES,
  TENANT_LOGO_DIMENSIONS,
  TENANT_SECTIONS_TO_VALIDATE,
  TENANT_SETTINGS_PATHS,
  TENANT_SETTINGS_SECTIONS
}

export const TENANT_REFERRAL_TITLES = {
  MAIN_TITLE: 'Tenant - Friend Referral',
  EDIT_MAIN: 'Edit Tenants Referral Program',
  ENABLE: 'Is the Friend Referral Program Enabled?',
  ENABLE_EDIT: 'Enable Referral Campaign',
  SCREEN_IMAGE: 'Screen Image',
  SCREEN_TITLE: 'Screen Title',
  SCREEN_DESCRIPTION: 'Screen Description',
  HOW_IT_WORKS: 'How does it Work - Title',
  HOW_IT_WORKS_DESCRIPTION: 'How does it Work - Content',
  COPY_LINK_TEXT: 'Copy Invite Link Text',
  LIMIT: 'Earning Time Frame',
  DAYS_TO_EXPIRED: 'Days the user has to use a referral after joining Rewards',
  GLOBAL_LIMIT:
    'Limit the times a referral code can be used to join Rewards (optional)',
  REFERRER_EARNING_POINTS: 'Referrer User Points',
  REFERRER_EARNING_TITLE: 'Referrer User Earning Transaction',
  REFEREE_EARNING_POINTS: 'Referee User Points',
  REFEREE_EARNING_TITLE: 'Referee User Earning Transaction',
  REFERRER_SEGMENTS: 'Segment to add the Referrer user',
  REFEREE_SEGMENTS: 'Segment to add the Referee user',
  REQUIRED_ACTION: 'Required action to complete the referral process',
  CAMPAIGN: 'Campaign Required',
  OFFER: 'Offer Required',
  ACTIONS_RELATIONSHIP: 'Relationship between the required actions',
  EARN_CAMPAIGN: 'Earn a Campaign',
  REDEEM_OFFER: 'Redeem an Offer',
  VERIFY_PHONE: 'Verify phone number',
  EDIT_REQUIRED_ACTION: 'Require an additional action to complete the referral',
  EDIT_CAMPAIGN: 'Select a Campaign',
  EDIT_OFFER: 'Select an Offer',
  NO_INSTRUCTIONS: 'There are no Steps Created',
  INSTRUCTION_DIALOG: 'Add Step Instruction'
}

export const FRIEND_REFERRAL_TABS = [
  'Referral Settings',
  'Referral Page',
  'Translations'
] as const

export const FRIEND_REFERRAL_TABS_INDEX = {
  REFERRAL_SETTINGS: 0,
  REFERRAL_PAGE: 1,
  TRANSLATIONS: 2
} as const

export const TENANT_REFERRAL_SUB_TITLES = {
  SCREEN: 'Refer a Friend Screen',
  LIMIT: 'Participation Limits',
  REWARD: 'Reward Points',
  SEGMENTATION: 'Segmentation',
  ADDITIONAL_SETTING: 'Additional Settings',
  VISIBILITY: 'Program Visibility',
  NO_INSTRUCTIONS: 'Press on the button to add a new Step.',
  INSTRUCTION_DIALOG: 'Step instruction'
}

export const TENANT_REFERRAL_SUB_DESCRIPTIONS = {
  SCREEN:
    'The following information will be displayed in the Refer a friend page.',
  LIMIT:
    'Define the limits for the use of a specific code to be referred to Rewards.',
  REWARD: 'Select to give out points to the Referrer or Referee users.',
  SEGMENTATION:
    'Select to add the users to a specific segment, once a referral code is added to Rewards.',
  ADDITIONAL_SETTING:
    'Define any additional action the Referee has to complete in order to complete the Referral process and receive a Reward.',
  VISIBILITY: 'Define if the Program is enabled for this Tenant.'
}

export const TENANT_REFERRAL_KEYS = {
  IsReferralAvailable: 'IsReferralAvailable',
  ReferralTitle: 'ReferralTitle',
  ReferralDescription: 'ReferralDescription',
  ReferralImageID: 'ReferralImageID',
  WelcomeButtonLabel: 'WelcomeButtonLabel',
  HowItWork: 'HowItWork',
  CopyLinkText: 'CopyLinkText',
  CopyLinkUrl: 'CopyLinkUrl',
  Unit: 'Unit',
  LimitCount: 'LimitCount',
  DaysToExpired: 'DaysToExpired',
  GlobalRepeatableLimit: 'GlobalRepeatableLimit',
  RewardsForReferrer: 'RewardsForReferrer',
  EarningTitleForReferrer: 'EarningTitleForReferrer',
  RewardsForReferee: 'RewardsForReferee',
  EarningTitleForReferee: 'EarningTitleForReferee',
  ReferrerTargetGroupID: 'ReferrerTargetGroupID',
  RefereeTargetGroupID: 'RefereeTargetGroupID',
  RequiredActionRelation: 'RequiredActionRelation',
  IsRequireCampaign: 'IsRequireCampaign',
  IsRequireOffer: 'IsRequireOffer',
  IsRequireVerifyPhoneNumber: 'IsRequireVerifyPhoneNumber',
  RequiredCampaignIDForEarning: 'RequiredCampaignIDForEarning',
  RequiredOfferIDForEarning: 'RequiredOfferIDForEarning',
  Description: 'Description'
}

export const REFERRAL_LIMITS_UNITS_OPTIONS = [
  {
    label: 'Day',
    value: 'DAY'
  },
  {
    label: 'ISO Week',
    value: 'ISO_WEEK'
  },
  {
    label: 'Month',
    value: 'MONTH'
  }
]

export const REQUIRED_ACTIONS_RELATIONSHIP_OPTIONS = [
  {
    label: 'AND',
    value: 'AND'
  },
  {
    label: 'OR',
    value: 'OR'
  }
]

export const FRIEND_REFERRAL_EDIT_SECTIONS = {
  REFERRAL_SETTINGS: 'referral-settings',
  REFERRAL_PAGE: 'referral-page'
} as const

type FriendReferralEditSection =
  (typeof FRIEND_REFERRAL_EDIT_SECTIONS)[keyof typeof FRIEND_REFERRAL_EDIT_SECTIONS]

export const FRIEND_REFERRAL_EDIT_SECTION_TITLES: Record<
  FriendReferralEditSection,
  string
> = {
  [FRIEND_REFERRAL_EDIT_SECTIONS.REFERRAL_SETTINGS]: 'Edit Referral Settings',
  [FRIEND_REFERRAL_EDIT_SECTIONS.REFERRAL_PAGE]: 'Edit Referral Page'
}

export const getFriendReferralEditPageTitle = (
  section: FriendReferralEditSection
): string => {
  return (
    FRIEND_REFERRAL_EDIT_SECTION_TITLES[section] ??
    TENANT_REFERRAL_TITLES.EDIT_MAIN
  )
}

export const MIN_REQUIRED_ACTIONS = 2

export const NO_EXIST_INDEX = -1

export const FRIEND_REFERRAL_TRANSLATION_SECTION_ORDER = [
  'friendReferral'
] as const

export const FRIEND_REFERRAL_TRANSLATION_SECTION_TITLES = {
  friendReferral: 'FRIEND REFERRAL'
} as const

export const FRIEND_REFERRAL_TRANSLATION_SECTION_FIELDS = {
  friendReferral: {
    screenTitle: 'Screen Title',
    screenDescription: 'Screen Description',
    howDoesItWorkTitle: 'How does it Work - Title',
    howDoesItWorkSteps: 'howDoesItWorkSteps'
  }
} as const
